import { render, staticRenderFns } from "./publicAdminEdit.vue?vue&type=template&id=62c7c9b6"
import script from "./publicAdminEdit.vue?vue&type=script&lang=js"
export * from "./publicAdminEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62c7c9b6')) {
      api.createRecord('62c7c9b6', component.options)
    } else {
      api.reload('62c7c9b6', component.options)
    }
    module.hot.accept("./publicAdminEdit.vue?vue&type=template&id=62c7c9b6", function () {
      api.rerender('62c7c9b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/publicAdmin/publicAdminEdit.vue"
export default component.exports